import * as React from "react";
import { Tag, VStack } from "@chakra-ui/react";
import { addDays, format } from "date-fns";
import { PageHeader, Search, Table, Wrapper } from "components";
import { useQueryParams } from "duck";
import { useGetAccessLogsQuery, AccessStatusEnum } from "requests";
import { Filter } from "./components";
import { ACCESS_TYPES } from "./duck";

const AccessLogs: React.FC = () => {
  const [{ search, pagination, filter }] = useQueryParams();
  const dateTo = filter?.dateTo
    ? format(addDays(new Date(filter?.dateTo), 1), "MM/dd/y")
    : null;

  const { data, loading } = useGetAccessLogsQuery({
    variables: {
      page: pagination?.page || 1,
      perPage: 15,
      filter: {
        ...((filter?.dateFrom || filter?.dateTo) && {
          range: {
            createdAt: { gte: filter?.dateFrom, lt: dateTo }
          }
        })
      },
      username: search
    },
    fetchPolicy: "cache-and-network"
  });

  return (
    <VStack spacing={6} alignItems="left">
      <PageHeader title="Access Logs" />
      <Wrapper mt={6}>
        <VStack alignItems="left" spacing={7}>
          <Search />
          <Filter />
          <Table
            data={data?.accessLogs?.collection || []}
            loading={loading}
            totalCount={data?.accessLogs?.paginationInfo?.totalCount || 0}
            perPage={15}
            noDataMessage="No results found"
          >
            <Table.Column
              dataKey="user"
              label="User ID"
              render={({ value }) => value._id}
            />
            <Table.Column
              dataKey="user"
              label="Username"
              render={({ value }) => `${value.firstName} ${value.lastName}`}
            />
            <Table.Column dataKey="ip" label="User IP" />
            <Table.Column
              dataKey="browser"
              label="User Browser"
              render={({ value }) => value}
            />
            <Table.Column
              dataKey="_id"
              label="Access Type"
              render={({ value }) => {
                const curRecord = data?.accessLogs?.collection.find(
                  el => el._id === value
                );
                return (
                  curRecord && (
                    <Tag
                      colorScheme={
                        curRecord.accessStatus === AccessStatusEnum.Successful
                          ? "green"
                          : "red"
                      }
                    >
                      {ACCESS_TYPES[curRecord.accessTypeEnum]}
                    </Tag>
                  )
                );
              }}
            />
            <Table.Column
              dataKey="createdAt"
              label="Date and Time"
              render={({ value }) =>
                format(new Date(value), "MM/dd/yyyy HH:mm")
              }
            />
          </Table>
        </VStack>
      </Wrapper>
    </VStack>
  );
};

export default AccessLogs;
